import React, { useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import songs from '../../../utilis/Song';
import Unlimitedmusicsign from '../../../assets/Images/Unlimitedmusicsign.svg';
import { Slide } from 'react-awesome-reveal';
import './SecondSection.scss';

function SecondSection() {
    // Pausing is tracked as a single flag rather than a hovered index —
    // the whole strip stops while the visitor is interacting with it.
    const [isPaused, setIsPaused] = useState(false);

    return (
        <Box className="second-section">
            <Container>
                <Slide direction="up" triggerOnce>
                    <Box className="second-section-heading">
                        <Box className="second-section-heading-svg">
                            <img src={Unlimitedmusicsign} alt="Unlimited Music Sign" className="music-sign" />
                            <Typography variant="h4" component="h2" className="section-title">
                                <span className="highlight">Unlimited Music Distribution</span>
                            </Typography>
                        </Box>
                        <Typography variant="h6" component="h2" className="section-description">
                            To 190+ Stores Worldwide for Free
                        </Typography>
                    </Box>
                </Slide>
            </Container>

            {/* Full-bleed strip: auto-scrolls on desktop, swipes on touch. */}
            <div
                className={`scrolling-wrapper ${isPaused ? 'paused' : ''}`}
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
            >
                <div className="cube-container">
                    {songs.map((song, index) => (
                        <div className="cube" key={`${index}-${song.url}`}>
                            <div className="iframe-container">
                                <iframe
                                    title={song.name}
                                    src={song.url}
                                    loading="lazy"
                                    frameBorder="0"
                                    allow="clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                ></iframe>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Box>
    );
}

export default SecondSection;
